import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_ANSWER_QUESTION_SURVEY,
  CREATE_FORM_QUESTION,
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  DELETE_ADDITIONAL_DATA_OPEN_TEXT,
  UPDATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION_STATUS,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
} from "../../GraphQL/Mutations";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { NotificationManager } from "react-notifications";
import { getStateLogin } from "../../containers/LayoutHome/stateLogin";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import { theme as themeConfig } from "../../themes/themes";
import MessageYesNo from "../MessageYesNo/index";
import ModalLoader from "../ModalLoader/ModalLoader";
import ModalSaveToBank from "../ModalSaveToBank";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  CloneButton,
  ContainerButtons,
  ContainerTitle,
  DeleteButton,
  EditButton,
  EditSection,
  GeneralStyle,
  LowerWrapper,
  QuestionWrapper,
  SaveToBank,
  CategorySection,
  UpperWrapper,
  VSection,
  TooltipCheckSection,
  TooltipDescriptionContainer,
  UploadInputContainer,
} from "./AttachFileBlock.styled";
import { clientPolicyIngsight } from "../../App";
import { messages } from "../../util/message";
import "react-datepicker/dist/react-datepicker.css";
import { Col, Row } from "react-bootstrap";
import InfoIcon from "@material-ui/icons/Info";
import CustomInputFileComponent from "../CustomInputFileComponent/CustomInputFileComponent";

const AttachFileBlock = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [categories, setcategories] = useState([]);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [getQuestionCategories] = useLazyQuery(ALL_QUESTION_CATEGORIES, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (!data.allCategoriesQuestion.withError) {
        const allCategories = data.allCategoriesQuestion.outputData.map(
          (c) => ({ ...c })
        );
        if (dataSurvey?.isGlobal) {
          setcategories(
            allCategories.filter((f) => f.description === "Global")
          );
        } else {
          setcategories(
            allCategories.filter((f) => f.description !== "Global")
          );
        }
      }
    },
  });
  const [showLoader, setshowLoader] = useState(false);
  const [createFormQuestion] = useMutation(CREATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestion] = useMutation(UPDATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestionStatus] = useMutation(UPDATE_FORM_QUESTION_STATUS, {
    client: clientPolicyIngsight,
  });
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [deleteAdditionalDataOpenText] = useMutation(
    DELETE_ADDITIONAL_DATA_OPEN_TEXT,
    {
      client: clientPolicyIngsight,
    }
  );
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState(0);
  const [mandatory, setMandatory] = useState(false);
  const [validationText, setValidationText] = useState("");
  const [colorBackground] = useState("#f9f9f9");
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "File",
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      setTitle(globalProps.GnameQuestion);
      setCategory(globalProps.GidCategoryQuestion);
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setValidationText(globalProps.GvalidationText);
      if (globalProps.GjsonConfiguration !== "") {
        setconfigQuestionStyle(JSON.parse(globalProps.GjsonConfiguration));
      }
    }
  }, []);

  useEffect(() => {
    if (responseMessageYesNo) {
      if (identity !== "form" && identity !== "additional-data") {
        handleDelete();
      } else if (identity === "additional-data") {
        handleDeleteAdditionalDataQuestion();
      } else {
        handleDeleteFormQuestion();
      }
    }
  }, [responseMessageYesNo]);

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };

  useEffect(() => {
    if (identity !== "form" && identity !== "additional-data") {
      getQuestionCategories();
    }
  }, []);

  let saveQuestionSurvey = (idQuestion, isMandatory, copyText) => {
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText !== "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "File",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: category,
            GnameQuestion: title + copyText,
            GvalidationText: validationText,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: mandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: category,
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: validationText,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      setshowLoader(false);
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 5,
          createUser: getStateLogin(),
        },
      }).then((data) => {});
    });
  };
  let updateInQuestionSurvey = (idInBank, isMandatory) => {
    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: category,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: validationText,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      setshowLoader(false);
    });
  };

  const saveFormQuestions = (clone) => {
    if (
      title.trim() !== "" &&
      ((mandatory && validationText !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !mandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        if (mandatory && validationText !== "") {
          setshowLoader(true);
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestion();
          } else {
            createQuestion(clone);
          }
        } else {
          if (!mandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          } else if (mandatory && validationText === "") {
            setshowLoader(true);
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  const updateQuestion = () => {
    configQuestionStyle.validationText = mandatory ? validationText : "";
    updateFormQuestion({
      variables: {
        idQuestionForm: globalProps.GidQuestion,
        questionTitle: title,
        questionType: "FILE_UPLOAD",
        isMandatory: mandatory,
        questionOrder: globalProps.Gorder,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
      },
    })
      .then((res) => {
        dispatch({
          type: "UPDATE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: "",
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: mandatory ? validationText : "",
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
        setshowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const createQuestion = (clone) => {
    let copyText = clone ? " - Copy" : "";
    configQuestionStyle.validationText = mandatory ? validationText : "";
    createFormQuestion({
      variables: {
        idForm: globalProps.GidSurvey,
        questionTitle: title + copyText,
        questionType: "FILE_UPLOAD",
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: mandatory,
        questionOrder: globalProps.Gorder,
      },
    })
      .then((res) => {
        if (res?.data?.createFormQuestion?.idForm) {
          let idQuestion = res.data.createFormQuestion.idQuestionForm;
          if (copyText != "") {
            dispatch({
              type: "CLONE_QUESTION",
              payload: {
                Gtype: "File",
                GindexQuestion: globalProps.GindexQuestion + 1,
                Gactive: true,
                GidSurvey: globalProps.GidSurvey,
                GidQuestion: idQuestion,
                GidCategoryQuestion: "",
                GnameQuestion: title + copyText,
                GvalidationText: mandatory ? validationText : "",
                GidQuestionSurvey: idQuestion,
                GisMandatory: mandatory,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
                Gorder: globalProps.Gorder + 1,
                GisEdit: false,
                GisDependent: false,
                GidParentQuestion: null,
                GdependentAnswer: null,
                clonePosition: globalProps.GindexQuestion + 1,
              },
            });
          } else {
            dispatch({
              type: "SAVE_QUESTIONS",
              payload: {
                GindexQuestion: globalProps.GindexQuestion,
                GisEdit: false,
                GnameQuestion: title,
                GidCategoryQuestion: "",
                GisMandatory: mandatory,
                Gorder: globalProps.Gorder,
                GvalidationText: mandatory ? validationText : "",
                GidQuestion: idQuestion,
                GidQuestionSurvey: idQuestion,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
              },
            });
          }
          setshowLoader(false);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let saveQuestionBank = (clone) => {
    if (
      title.trim() !== "" &&
      parseInt(category) !== 0 &&
      ((mandatory && validationText !== "") ||
        (tooltipInformationCheck && tooltipDescriptionText !== "") ||
        !mandatory ||
        !tooltipInformationCheck)
    ) {
      if (
        !tooltipInformationCheck ||
        (tooltipInformationCheck && tooltipDescriptionText !== "")
      ) {
        let copyText = clone ? " - Copy" : "";
        setshowLoader(true);
        if (mandatory && validationText !== "") {
          if (globalProps.GidQuestionSurvey && !clone) {
            updateQuestionBank({
              variables: {
                idQuestion: globalProps.GidQuestion,
                nameQuestion: title,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                lastUpdateUser: getStateLogin(),
              },
            })
              .then(() => {
                updateInQuestionSurvey(globalProps.GidQuestion, mandatory);
              })
              .catch((error) => {
                setshowLoader(false);
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          } else {
            createQuestionBank({
              variables: {
                nameQuestion: title + copyText,
                validationText: validationText,
                idCategoryQuestion: parseInt(category),
                active: true,
                createUser: getStateLogin(),
              },
            })
              .then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  mandatory,
                  copyText
                );
              })
              .catch((error) => {
                setshowLoader(false);
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          }
        } else {
          if (!mandatory) {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              })
                .then(() => {
                  updateInQuestionSurvey(globalProps.GidQuestion, mandatory);
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: "",
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              })
                .then((saveResponse) => {
                  saveQuestionSurvey(
                    saveResponse.data.createQuestionBank,
                    mandatory,
                    copyText
                  );
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            }
          } else if (mandatory && validationText === "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              })
                .then(() => {
                  updateInQuestionSurvey(globalProps.GidQuestion, mandatory);
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              })
                .then((saveResponse) => {
                  saveQuestionSurvey(
                    saveResponse.data.createQuestionBank,
                    mandatory,
                    copyText
                  );
                })
                .catch((error) => {
                  setshowLoader(false);
                  const errorMessage = error.message.split("\n")[0];
                  NotificationManager.error(errorMessage, "", 5000);
                });
            }
          }
        }
      } else {
        handleNoTooltipDesMessage();
      }
    } else {
      handleNoQuestionTitle();
      handleNoCategory();
      handleNoMandatoryText();
      handleNoTooltipDesMessage();
    }
  };

  let handleNoQuestionTitle = () => {
    if (title.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = () => {
    if (parseInt(category) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = () => {
    if (mandatory && validationText === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (stateQuestionsReducer.questions.filter((f) => f.GisEdit).length) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };

  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];
    setTitle(objG.GnameQuestion);
    setCategory(objG.GidCategoryQuestion);
    setMandatory(
      objG.GisMandatory && objG.GisMandatory !== null
        ? objG.GisMandatory
        : false
    );
    setValidationText(objG.GvalidationText);
    const jsonConfig = JSON.parse(objG.GjsonConfiguration);

    if (jsonConfig.tooltip) {
      setTooltipInformationCheck(jsonConfig.tooltip.status);
      setTooltipDescriptionText(jsonConfig.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };

  const handleDeleteAdditionalDataQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey) {
      deleteAdditionalDataOpenText({
        variables: {
          openTextQuestionId: globalProps.GidQuestionSurvey,
        },
      })
        .then((res) => {
          if (res?.data?.deleteAdditionalDataOpenText) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.map((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  const deleteNonSavedQuestion = () => {
    setshowLoader(false);
    let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
    copy.questions.splice(globalProps.GindexQuestion, 1);
    copy.questions.map((q, index) => {
      q.GindexQuestion = index;
      q.Gorder = index + 1;
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "DELETE_QUESTIONS", payload: copy });
  };

  const handleDeleteFormQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestion) {
      updateFormQuestionStatus({
        variables: {
          idFormQuestion: globalProps.GidQuestion,
          newFormQuestionStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res?.data?.changeStatusFormQuestion?.idQuestionForm) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.map((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.map((q, index) => {
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let renderTitle = (title) => {
    if (identity === "additional-data") {
      if (title) {
        return title;
      } else {
        return "Free text field";
      }
    } else {
      return title;
    }
  };

  let handleTextAreaText = (value) => {
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipDescriptionText(value);
  };

  return (
    <GeneralStyle
      isDependent={globalProps.GisDependent}
      editable={globalProps.GisEdit}
      colorBackground={
        configQuestionStyle.customStyle
          ? configQuestionStyle.background
          : colorBackground
      }
    >
      {globalProps.GisEdit ? (
        <EditSection>
          <VSection>
            <FormControlLabel
              control={
                <Checkbox
                  checked={mandatory}
                  onChange={(e) => setMandatory(e.target.checked)}
                  name="mandatory-check"
                />
              }
              label="Mandatory Question"
            />
            {mandatory && identity !== "additional-data" ? (
              <input
                onChange={(e) => setValidationText(e.target.value)}
                type="text"
                placeholder="Enter mandatory message here"
                id="mText"
                defaultValue={validationText}
              ></input>
            ) : (
              <></>
            )}
          </VSection>
          <hr />
          <UpperWrapper>
            <QuestionWrapper>
              <label>Question:</label>
              <textarea
                onChange={(e) => setTitle(e.target.value)}
                type="text"
                placeholder="Enter your question here"
                defaultValue={title}
              ></textarea>
            </QuestionWrapper>
            {identity !== "form" && identity !== "additional-data" && (
              <>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <CategorySection>
                      <div>
                        <label>Category</label>
                        <select
                          onChange={(e) => setCategory(e.target.value)}
                          value={category.toString()}
                        >
                          <option value={0}>- Category -</option>
                          {categories.map(
                            ({
                              recordState,
                              description,
                              idCategoryQuestion,
                            }) => {
                              if (recordState.toUpperCase() == "ACTIVE") {
                                return (
                                  <option
                                    key={idCategoryQuestion}
                                    value={idCategoryQuestion}
                                  >
                                    {description}
                                  </option>
                                );
                              }
                              return null;
                            }
                          )}
                        </select>
                      </div>
                    </CategorySection>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "35px",
                      paddingTop: "20px",
                    }}
                  >
                    <TooltipCheckSection>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tooltipInformationCheck}
                            onChange={(e) => {
                              changeTooltipInformationCheck(e.target.checked);
                            }}
                            name="tooltip-info-check"
                          />
                        }
                        label="Add information tooltip to question"
                      />
                    </TooltipCheckSection>
                  </Grid>
                </Grid>
                {tooltipInformationCheck && (
                  <Grid
                    container
                    style={{ display: "flex", alignContent: "flex-end" }}
                  >
                    <Grid item xs={12} sm={3}>
                      <></>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TooltipDescriptionContainer>
                        <textarea
                          style={{ height: "80px", resize: "none" }}
                          onChange={(e) => handleTextAreaText(e.target.value)}
                          type="text"
                          placeholder="Type text here..."
                          id="tooltipDescription"
                          defaultValue={tooltipDescriptionText}
                        ></textarea>
                      </TooltipDescriptionContainer>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </UpperWrapper>
        </EditSection>
      ) : (
        <></>
      )}

      <LowerWrapper>
        <ContainerTitle
          style={
            configQuestionStyle.customStyle
              ? configQuestionStyle.question
              : stateQuestionsReducer.globalStyle.questions
          }
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {renderTitle(title)}
            {tooltipInformationCheck && tooltipDescriptionText !== "" && (
              <Tooltip
                placement="right"
                open={showTooltipDescription}
                title={
                  <>
                    <Box
                      style={{
                        margin: "0",
                        listStyleType: "circle",
                        lineHeight: "1.3",
                        fontSize: "13px",
                      }}
                    >
                      <span>{tooltipDescriptionText}</span>
                    </Box>
                  </>
                }
                arrow
              >
                <IconButton
                  onClick={() => {
                    setShowTooltipDescription(!showTooltipDescription);
                  }}
                >
                  <InfoIcon
                    fontSize="small"
                    style={{
                      cursor: "pointer",
                      color: themeConfig.text.primary,
                      width: "18px",
                      height: "18px",
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </ContainerTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            width: "100%",
          }}
        ></Box>
        <Col
          md={12}
          className={"my-3"}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Row style={{ width: "100%" }}>
            <Col md="12">
              <LowerWrapper>
                <UploadInputContainer>
                  <CustomInputFileComponent
                    componentConfiguration={globalProps}
                    itsPreview={false}
                  ></CustomInputFileComponent>
                </UploadInputContainer>
              </LowerWrapper>
            </Col>
          </Row>
        </Col>
      </LowerWrapper>
      {!globalProps.GisEdit &&
        globalProps.GidQuestionSurvey &&
        !globalProps.questionBank && (
          <div className="overlay-option">
            <div className="bottom-buttons">
              <CloneButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => {
                  if (identity !== "form" && identity !== "additional-data") {
                    saveQuestionBank(true);
                  } else {
                    saveFormQuestions(true);
                  }
                }}
              >
                <CloneIcon />
                Clone
              </CloneButton>
              {identity !== "form" && identity !== "additional-data" && (
                <SaveToBank
                  hidden={globalProps.disableButton}
                  className="w-25 mt-2 mb-3"
                  onClick={() => handleSaveToBank()}
                >
                  Save to bank
                </SaveToBank>
              )}
              <DeleteButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                Delete
              </DeleteButton>
              {identity !== "additional-data" && (
                <EditButton
                  hidden={globalProps.disableButton}
                  className="w-25 mt-2 mb-3"
                  onClick={() => handleEdit()}
                >
                  Edit
                </EditButton>
              )}
            </div>
          </div>
        )}
      {globalProps.GisEdit && (
        <ContainerButtons>
          {/* {alreadySaved ? ( */}
          <div className="left-container">
            {identity !== "additional-data" && (
              <StyledButtonGenericQuestion
                onClick={() => {
                  setshowStyleEdit(true);
                }}
              >
                <StyleQuestion />
                Style
              </StyledButtonGenericQuestion>
            )}

            {globalProps.GisEdit && globalProps.GidQuestionSurvey ? (
              <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                <CancelQuestion />
                Cancel
              </StyledButtonGenericQuestion>
            ) : null}
            <StyledButtonGenericQuestion
              lastElement={true}
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              <DeleteQuestion />
              Delete
            </StyledButtonGenericQuestion>
          </div>
          {
            <div className="right-container">
              <StyledButton
                onClick={() => {
                  if (identity !== "form" && identity !== "additional-data") {
                    saveQuestionBank(false);
                  } else {
                    saveFormQuestions(false);
                  }
                }}
              >
                Save
              </StyledButton>
            </div>
          }
        </ContainerButtons>
      )}
      {showStyleEdit && (
        <StyleQuestionContainer
          setshowStyleEdit={setshowStyleEdit}
          stateObject={configQuestionStyle}
          setstateObject={setconfigQuestionStyle}
        ></StyleQuestionContainer>
      )}
      {openMessageYesNoModal && (
        <MessageYesNo
          setOpenMessageYesNoModal={setOpenMessageYesNoModal}
          message="Are you sure you want to delete this question?"
          setResponse={setResponse}
        ></MessageYesNo>
      )}
      {showLoader && <ModalLoader></ModalLoader>}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={category}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </GeneralStyle>
  );
};

export default AttachFileBlock;
